import type { Component } from 'vue'
import type {
  RenDecorationComponent,
  RenDecorationPreviewData,
  RenDecorationThemeTokens
} from '../../types'

export type DecorationWidgetConfig = {
  type: string
  name: string
  icon: string
  group: string
  description: string
  aliases?: string[]
  defaultProps?: Record<string, unknown>
}

export type DecorationWidgetModule = DecorationWidgetConfig & {
  template: Component
  settings?: Component
}

/** 画布预览标准入参。宽高/边距/圆角由 WidgetBox 处理，template 不要再写。 */
export type WidgetPreviewProps = {
  component: RenDecorationComponent
  componentData?: unknown
  previewData?: RenDecorationPreviewData
  themeColor?: string
  themeTokens?: RenDecorationThemeTokens
}

/** 内容设置标准入参。启用、导航、样式 Tab 在检查器壳上，settings 只改 props。 */
export type WidgetSettingsProps = {
  component: RenDecorationComponent
  readonly?: boolean
}

export type WidgetSettingsEmits = {
  'update:props': [props: Record<string, unknown>]
  'pick-item-link': [index: number]
}

export function mergeWidgetProps(
  component: RenDecorationComponent,
  partial: Record<string, unknown>
): Record<string, unknown> {
  return { ...(component.props ?? {}), ...partial }
}
